import getCdnResource from './getCdnResource';

const getCdnBcIoImg = (handle: string) =>
  getCdnResource(`luxury/icons/${handle}`);

export default getCdnBcIoImg;
